
//ProtectRoute
import { Navigate, useLocation } from "react-router-dom";
import { loginDestination } from "../utils/notificationReturn";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) return <div>Loading...</div>; // Prevent premature redirect

    return user ? children : <Navigate to={loginDestination(location.pathname)} replace />;
};

export default ProtectedRoute;




